import gql from 'graphql-tag';

import { getGraphQLClient } from 'utilities/graphql';
import * as logger from 'utilities/loggerx';

const updateLastWatchTimeMutaiton = gql`
  mutation ($videoId: ID!, $timestamp: Int) {
    updateLastWatchTime(videoId: $videoId, timestamp: $timestamp) {
      ... on UpdateWatchTimePayload {
        success
      }
    }
  }
`;

export const updateLastWatchTime = (videoId, timestamp) => {
  if (!videoId) {
    return;
  }

  const newTimestamp = parseInt(timestamp) || null;

  const gqlClient = getGraphQLClient();

  return gqlClient
    .mutate({
      mutation: updateLastWatchTimeMutaiton,
      variables: {
        videoId,
        timestamp: newTimestamp,
      },
    })
    .catch(error => {
      logger.error(
        error,
        {
          message: `LastWatched: Unable to update watch time`,
        },
        { team: logger.CREATE_TEAM }
      );

      throw error;
    });
};
